import { useHydrateFavoritesFromSearch } from '@carvana/merch-favorites';
import { useContext, useMemo } from 'react';
import httpWithAuth from '~/clients/httpWithAuth';
import { environment } from '~/constants/environment';
import DeviceContext, { useIsMobile } from '~/context/common/DeviceContext';
import StaticContext, { useReferrer } from '~/context/common/StaticContext';
import UserContext, { useUserLocation } from '~/context/common/UserContext';
import FavoritesContext from '~/context/home/FavoritesContext';
import BrowserCookies from '~/utilities/BrowserCookies';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useConvertFavoriteToSearch() {
  const { favorites } = useContext(UserContext);
  const { favoriteVehiclesFromSearch } = useContext(FavoritesContext);
  const { zip } = useUserLocation();
  const { clientId } = useContext(StaticContext);
  const { browserName } = useContext(DeviceContext);
  const isMobile = useIsMobile();

  useHydrateFavoritesFromSearch({
    analyticsData: {
      browser: browserName ?? '',
      clientId,
      deviceName: '',
      isMobileDevice: isMobile,
      referrer: useReferrer()
    },
    browserCookieId: BrowserCookies.get('BrowserCookieId') ?? '',
    environment,
    favoriteVehicles: favorites.data,
    fetcherWithAuth: httpWithAuth,
    hasAppliedTrade: false,
    inventoryVehicles: favoriteVehiclesFromSearch,
    onError: useMemo(
      () => generateErrorLogger('fetch search with favorites'),
      []
    ),
    shouldFetch: favorites.isLoaded,
    zip
  });
}
